import { GenericDebouncer } from "@vortex/shared";
export default class Debouncer extends GenericDebouncer {
    constructor(func, debounceMS, reset, triggerImmediately = false) {
        const boundSetTimeout = window.setTimeout.bind(window);
        const boundClearTimeout = window.clearTimeout.bind(window);
        super(boundSetTimeout, boundClearTimeout, func, debounceMS, reset, triggerImmediately);
    }
}
